import React from 'react';

const IMG = (name) => `${process.env.PUBLIC_URL}/images/${name}`;

const CONTACT = {
  instagram: '@_ICONNECT_00',
  instagramUrl: 'https://instagram.com/_ICONNECT_00',
  email: 'Iconnectthodar833@gmail.com',
  branch: 'Moodbidri Thodar, Dakshina Kannada — 574227',
};

const TEAM = [
  { name: 'Mohammad Sawaar', role: 'Managing Director', image: 'managing_director.png' },
   { name: 'Mallikajun Pattar', role: 'Chief Executive Officer', image: 'ceo.png' },
  { name: 'Mohammad Arshad', role: 'Chief Operating Officer', image: 'coo.png' },
 
];

const MISSION_EN = [
  { kind: 'bullet', text: 'Customers purchase plan-helping customers to purchase dream products/improve lifestyle.' },
  { kind: 'bullet', text: 'Establish 500 mobile and electronics showrooms Across India.' },
  { kind: 'ordered', n: 1, text: 'Open 500 grocery stores across Karnataka india' },
  { kind: 'ordered', n: 2, text: 'Creating employment opportunities for thousands of young people across India.' },
  { kind: 'bullet', text: 'Assist individuals in realising their dreams.' },
  { kind: 'bullet', text: 'The ultimate goal is for iconnect group to become the most valuable company by 2030.' },
];

const MISSION_KN = [
  { kind: 'bullet', text: 'ಗ್ರಾಹಕರಿಗೆ ತಮ್ಮ ಕನಸಿನ ಉತ್ಪನ್ನಗಳನ್ನು ಖರೀದಿಸಲು ಹಾಗೂ ಜೀವನಮಟ್ಟವನ್ನು ಉತ್ತಮಗೊಳಿಸಲು ಸಹಾಯ ಮಾಡುವುದು.' },
  { kind: 'bullet', text: 'ಭಾರತದೆಲ್ಲೆಡೆ 500 ಮೊಬೈಲ್ ಮತ್ತು ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ಶೋರೂಮ್‌ಗಳನ್ನು ಸ್ಥಾಪಿಸುವುದು.' },
  { kind: 'ordered', n: 1, text: 'ಭಾರತದ ಕರ್ನಾಟಕದಲ್ಲಿ 500 ಹೆಚ್ಚು ಗ್ರೋಸರಿ ಅಂಗಡಿಗಳು ಪ್ರಾರಂಭಿಸಿರುತ್ತೇವೆ.' },
  { kind: 'ordered', n: 2, text: 'ಭಾರತದೆಲ್ಲೆಡೆ ಸಾವಿರಾರು ಯುವಕರಿಗೆ ಉದ್ಯೋಗಾವಕಾಶಗಳನ್ನು ಸೃಷ್ಟಿಸುವುದು.' },
  { kind: 'bullet', text: 'ವ್ಯಕ್ತಿಗಳು ತಮ್ಮ ಕನಸುಗಳನ್ನು ಸಾಕಾರಗೊಳಿಸಲು ಸಹಾಯ ಮಾಡುವುದು.' },
  { kind: 'bullet', text: '2030ರೊಳಗೆ ಐಕನೆಕ್ಟ್ ಗ್ರೂಪ್ ಅನ್ನು ಅತ್ಯಂತ ಮೌಲ್ಯಯುತ ಕಂಪನಿಯಾಗಿಸುವುದು ಅಂತಿಮ ಗುರಿ.' },
];

const TERMS_EN = [
  'GST is applicable on all goods ranging from 5% to 28 % depending on the product category',
  'Customer who redeem their coupons after 10 months will get an additional 10% standard discount from the company',
  'Cash will not be given in place of prizes',
  { note: true, text: 'NOTE :- no refunds will be issued under any circumstances' },
  'Free shipping is available for customer redeem product',
  'All coupons redeem products are I connect company brand',
  '5% TDS deducting on every income payment',
];

const TERMS_KN = [
  'ಎಲ್ಲಾ ವಸ್ತುಗಳಿಗೆ GST ಅನ್ವಯವಾಗುತ್ತದೆ ಉತ್ಪನ್ನದವರ್ಗದ ಆದರದ ಮೇಲೆ 5% ರಿಂದ 28% ವರೆಗೆ GST ವಿಧಿಸಲಾಗುತ್ತದೆ',
  'ಗ್ರಾಹಕರು 10 ತಿಂಗಳ ನಂತರ ಕೂಪನ್ ರಿಡೀಮ್ ಮಾಡಿದರೆ ಕಂಪನಿಯಿಂದ ಹೆಚ್ಚುವರಿ 10% ಸಾಮಾನ್ಯ ರಿಯಾಯತಿ ನೀಡಲಾಗುತ್ತದೆ',
  'ಬಹುಮಾನಗಳ ಬದಲಿಗೆ ನಗದು ನೀಡಲಾಗುವುದಿಲ್ಲ',
  { note: true, text: 'ಸೂಚನೆ : ಯಾವುದೇ ಸಂದರ್ಭದಲ್ಲಿಯೂ ಹಣ ಮರುಪಾವತಿ (refund) ನೀಡಲಾಗುವುದಿಲ್ಲ' },
  'ಉತ್ಪನ್ನಗಳನ್ನು ರಿಡೀಮ್ ಮಾಡುವ ಗ್ರಾಹಕರಿಗೆ ಉಚಿತ ಡೆಲಿವರಿ ಸೌಲಭ್ಯವಿದೆ',
  'ಕೂಪನ್ ಮೂಲಕ ರಿಡೀಮ್ ಮಾಡುವ ಎಲ್ಲಾ ಉತ್ಪನ್ನಗಳು iconnect ಕಂಪನಿ ಬ್ರ್ಯಾಂಡ್ ಗಳಾಗಿರುತ್ತವೆ',
  'ಪ್ರತಿಯೊಂದು ಆದಾಯ ಪಾವತಿಯಿಂದ 5% TDS ಕಡಿತಗೊಳಿಸಲಾಗುತ್ತದೆ',
  'ಹತ್ತು ತಿಂಗಳ ಕಂತು ಸಂಪೂರ್ಣವಾಗಿ ಮುಗಿದ ನಂತರವೇ ಗ್ರಾಹಕರಿಗೆ ವಸ್ತುಗಳು ಸಿಗುತ್ತವೆ. ಒಂದು ವೇಳೆ ಮದ್ಯದಲ್ಲಿ ಕಂತು ಪಾವತಿಸುವುದನ್ನು ನಿಲ್ಲಿಸಿದರೆ ಯಾವುದೇ ವಸ್ತುವಾಗಲಿ ಅಥವಾ ಹಣವಾಗಲಿ ಮರಳಿ ಸಿಗುವುದಿಲ್ಲ.',
];

const UPCOMING_PROJECTS = [
  { title: 'I Mobile branches', image: 'i_mobile.png' },
  { title: 'I Textiles', image: 'i_textiles.png' },
  { title: 'I Electronics', image: 'i_electronics.png' },
  { title: 'I Marts', image: 'i_marts.png' },
  { title: 'I Mobile repairing center', image: 'i_mobile_repair_centers.png' },
  { title: 'I Trading academy', image: 'i_trading_academy.png' },
];

function IconTarget({ className = 'h-7 w-7' }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.6} stroke="currentColor" aria-hidden>
      <circle cx="12" cy="12" r="7.5" strokeLinecap="round" />
      <circle cx="12" cy="12" r="3" />
      <path strokeLinecap="round" d="M12 3v2.5M12 18.5V21M3 12h2.5M18.5 12H21" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M18.5 5.5L16 8l2.5 2.5" />
    </svg>
  );
}

function IconInstagram({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    </svg>
  );
}

function IconMail({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.65} stroke="currentColor" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  );
}

function IconMapPin({ className = 'h-5 w-5' }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.65} stroke="currentColor" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 21s7-4.35 7-10a7 7 0 1 0-14 0c0 5.65 7 10 7 10Z" />
      <circle cx="12" cy="11" r="2.25" />
    </svg>
  );
}

function AboutFooter() {
  const linkCls =
    'font-medium text-cyan-200/95 underline decoration-cyan-500/40 underline-offset-2 transition hover:text-white hover:decoration-cyan-300/70';

  return (
    <footer className="relative overflow-hidden">
      <div
        className="h-0.5 w-full bg-gradient-to-r from-indigo-400 via-cyan-400 to-violet-400"
        aria-hidden
      />
      <div className="bg-gradient-to-br from-slate-950 via-indigo-950 to-slate-900 text-slate-300">
        <div className="pointer-events-none absolute inset-0 opacity-[0.12]" aria-hidden>
          <div
            className="absolute -left-1/4 top-0 h-full w-1/2 bg-[radial-gradient(ellipse_at_center,rgba(56,189,248,0.35),transparent_70%)]"
          />
          <div
            className="absolute -right-1/4 bottom-0 h-full w-1/2 bg-[radial-gradient(ellipse_at_center,rgba(129,140,248,0.3),transparent_70%)]"
          />
        </div>

        <div className="relative mx-auto flex max-w-6xl flex-col gap-3 px-4 py-3.5 sm:px-6 sm:py-4 lg:flex-row lg:items-center lg:justify-between lg:gap-8 lg:py-3.5">
          <div className="flex min-w-0 flex-1 flex-col gap-2.5 text-[11px] leading-snug sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-1 sm:gap-y-2 lg:gap-x-0">
            <a
              href={CONTACT.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex max-w-full items-center gap-2 rounded-lg px-1 py-0.5 transition hover:bg-white/5"
            >
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-white/10 text-white ring-1 ring-white/15">
                <IconInstagram className="h-3.5 w-3.5" />
              </span>
              <span>
                <span className="block text-[9px] font-semibold uppercase tracking-wider text-slate-500">Instagram</span>
                <span className={`${linkCls} text-[11px]`}>{CONTACT.instagram}</span>
              </span>
            </a>

            <span className="hidden h-4 w-px shrink-0 bg-white/15 sm:block" aria-hidden />

            <a
              href={`mailto:${CONTACT.email}`}
              className="inline-flex max-w-full items-center gap-2 rounded-lg px-1 py-0.5 transition hover:bg-white/5 sm:max-w-[min(100%,280px)]"
            >
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-white/10 text-white ring-1 ring-white/15">
                <IconMail className="h-3.5 w-3.5" />
              </span>
              <span className="min-w-0">
                <span className="block text-[9px] font-semibold uppercase tracking-wider text-slate-500">Email</span>
                <span className={`${linkCls} block truncate text-[11px] sm:whitespace-normal`}>{CONTACT.email}</span>
              </span>
            </a>

            <span className="hidden h-4 w-px shrink-0 bg-white/15 lg:block" aria-hidden />

            <div className="inline-flex min-w-0 max-w-full items-start gap-2 rounded-lg px-1 py-0.5 lg:max-w-md">
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-white/10 text-cyan-200 ring-1 ring-white/15">
                <IconMapPin className="h-3.5 w-3.5" />
              </span>
              <span className="min-w-0">
                <span className="block text-[9px] font-semibold uppercase tracking-wider text-slate-500">Registered office</span>
                <span className="block text-[11px] font-medium text-slate-200/95">{CONTACT.branch}</span>
              </span>
            </div>
          </div>

          <div className="flex justify-center border-t border-white/10 pt-3 lg:mt-0 lg:shrink-0 lg:border-t-0 lg:pt-0 lg:pl-2">
            <div className="rounded-lg border border-white/15 bg-white/[0.07] px-2.5 py-1.5 shadow-inner shadow-black/20 ring-1 ring-white/5 backdrop-blur-sm">
              <img
                src={IMG('company_logo.png')}
                alt="ICONNECT LLP"
                className="mx-auto h-8 w-auto max-w-[120px] object-contain opacity-[0.98] sm:h-9 sm:max-w-[140px]"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 px-4 py-2 text-center sm:px-6">
          <p className="text-[10px] font-medium tracking-wide text-slate-500">
            © {new Date().getFullYear()} ICONNECT LLP · <span className="text-slate-400">SuccessFlow</span>
          </p>
        </div>
      </div>
    </footer>
  );
}

function SectionLabel({ kicker, title, subtitle, align = 'left' }) {
  const alignCls = align === 'center' ? 'text-center mx-auto' : '';
  const line = (
    <div
      className={`mt-4 h-1 w-16 rounded-full bg-gradient-to-r from-indigo-500 via-cyan-500 to-violet-500 shadow-[0_4px_20px_rgba(99,102,241,0.25)] ${align === 'center' ? 'mx-auto' : ''}`}
    />
  );
  return (
    <div className={`mb-10 sm:mb-12 ${alignCls}`}>
      <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-indigo-600/90">{kicker}</p>
      <h2
        className="mt-2 text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl lg:text-[2rem]"
        style={{ fontFamily: "'DM Serif Display', Georgia, serif" }}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-2 max-w-2xl text-sm leading-relaxed text-slate-600 ${align === 'center' ? 'mx-auto' : ''}`}>{subtitle}</p>
      )}
      {line}
    </div>
  );
}

function GlassPanel({ children, className = '' }) {
  return (
    <div
      className={`rounded-[1.75rem] border border-white/90 bg-white/70 shadow-[0_25px_70px_-20px_rgba(79,70,229,0.18),0_8px_32px_-12px_rgba(15,23,42,0.08)] backdrop-blur-2xl ring-1 ring-indigo-950/[0.04] ${className}`}
    >
      {children}
    </div>
  );
}

function MissionList({ items }) {
  return (
    <ul className="space-y-4 text-sm leading-relaxed text-slate-700 sm:text-[0.9375rem]">
      {items.map((item, i) => (
        <li key={i} className="flex gap-3.5">
          {item.kind === 'ordered' ? (
            <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-indigo-600 to-cyan-600 text-xs font-bold text-white shadow-md">
              {item.n}
            </span>
          ) : (
            <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gradient-to-br from-indigo-500 to-cyan-500 shadow-sm" aria-hidden />
          )}
          <span>{item.text}</span>
        </li>
      ))}
    </ul>
  );
}

function TermsList({ items, listId }) {
  return (
    <ul id={listId} className="mt-2 space-y-4 text-sm leading-relaxed text-slate-700 sm:text-[0.9375rem]">
      {items.map((item, i) => {
        const isNote = typeof item === 'object' && item.note;
        const text = isNote ? item.text : item;
        return (
          <li
            key={i}
            className={`flex gap-3.5 ${isNote ? 'rounded-xl border border-amber-200/90 bg-amber-50/80 px-4 py-3.5 sm:px-5' : ''}`}
          >
            <span
              className={`mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full shadow-sm ${
                isNote ? 'bg-amber-500' : 'bg-gradient-to-br from-indigo-500 to-cyan-500'
              }`}
              aria-hidden
            />
            <span className={isNote ? 'font-semibold text-amber-950' : ''}>{text}</span>
          </li>
        );
      })}
    </ul>
  );
}

function BilingualBlockHeader({ icon, title, subtitle, langLabel }) {
  return (
    <header className="mb-5 text-left">
      <div className="flex items-start justify-between gap-4">
        <div className="flex min-w-0 items-start gap-3">
          <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-indigo-700 to-slate-800 text-white shadow-md">
            {icon}
          </span>
          <div className="min-w-0">
            {langLabel && (
              <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-indigo-600/90">{langLabel}</p>
            )}
            <h3
              className="mt-1 text-lg font-semibold tracking-tight text-slate-900 sm:text-xl"
              style={{ fontFamily: "'DM Serif Display', Georgia, serif" }}
            >
              {title}
            </h3>
            {subtitle && <p className="mt-1 text-xs text-slate-500">{subtitle}</p>}
          </div>
        </div>
      </div>
      <div className="mt-4 h-0.5 w-full max-w-[12rem] rounded-full bg-gradient-to-r from-indigo-500 via-cyan-500 to-violet-500 opacity-80" aria-hidden />
    </header>
  );
}

function About() {
  return (
    <div className="relative min-h-screen overflow-x-hidden bg-gradient-to-br from-slate-50 via-indigo-50/35 to-cyan-50/40 text-slate-800">
      {/* Soft ambient orbs */}
      <div className="pointer-events-none fixed inset-0 bg-gradient-to-b from-white/80 via-transparent to-cyan-50/30" aria-hidden />
      <div
        className="pointer-events-none fixed inset-0 opacity-[0.85]"
        style={{
          background:
            'radial-gradient(ellipse 85% 50% at 50% -10%, rgba(165,180,252,0.35), transparent 50%), radial-gradient(ellipse 45% 38% at 100% 5%, rgba(207,250,254,0.7), transparent 45%), radial-gradient(ellipse 40% 35% at 0% 35%, rgba(199,210,254,0.45), transparent 42%)',
        }}
        aria-hidden
      />
      <div className="pointer-events-none fixed bottom-0 left-1/2 h-[min(55vh,480px)] w-[min(92vw,880px)] -translate-x-1/2 rounded-full bg-gradient-to-t from-cyan-200/25 via-indigo-200/20 to-transparent blur-3xl" aria-hidden />

      <div className="relative z-10">
        {/* Hero */}
        <section className="px-4 pb-14 pt-10 sm:pb-20 sm:pt-14">
          <div className="mx-auto max-w-4xl text-center">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-indigo-200/80 bg-white/70 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-indigo-700 shadow-md shadow-indigo-200/30 backdrop-blur-md">
              About the company
            </div>
            <h1
              className="bg-gradient-to-br from-slate-900 via-indigo-800 to-cyan-700 bg-clip-text text-4xl font-semibold leading-[1.1] tracking-tight text-transparent sm:text-5xl lg:text-6xl"
              style={{ fontFamily: "'DM Serif Display', Georgia, serif" }}
            >
              ICONNECT LLP
            </h1>
            <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">
              The team and vision behind <span className="font-semibold text-slate-800">SuccessFlow</span> — a diversified group
              building retail, services, and platforms with one promise:{' '}
              <span className="bg-gradient-to-r from-indigo-600 to-cyan-600 bg-clip-text font-semibold text-transparent">
                one connection, endless value.
              </span>
            </p>
          </div>
        </section>

        {/* Company */}
        <section className="px-4 pb-16 sm:pb-20" aria-labelledby="company-heading">
          <div className="mx-auto max-w-6xl">
            <GlassPanel className="overflow-hidden p-8 sm:p-10 lg:grid lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:gap-12 lg:p-14">
              <div className="min-w-0">
                <p id="company-heading" className="text-[11px] font-semibold uppercase tracking-[0.22em] text-indigo-600">
                  Company
                </p>
                <h2 className="mt-2 text-3xl font-semibold text-slate-900 sm:text-4xl" style={{ fontFamily: "'DM Serif Display', Georgia, serif" }}>
                  Who we are
                </h2>
                <p className="mt-3 text-sm font-semibold uppercase tracking-[0.16em] text-indigo-700/90">ICONNECT LLP</p>
                <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-600 sm:text-base">
                  From consumer electronics to grocery, training to repairs — we are scaling trusted brands and physical
                  footprints across India with disciplined execution and long-term partnerships.
                </p>

                <dl className="mt-10 space-y-5 border-t border-slate-200/80 pt-10 text-sm">
                  <div>
                    <dt className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Instagram</dt>
                    <dd className="mt-1">
                      <a
                        href={CONTACT.instagramUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-semibold text-indigo-700 underline decoration-indigo-300 underline-offset-2 transition hover:text-indigo-900"
                      >
                        {CONTACT.instagram}
                      </a>
                    </dd>
                  </div>
                  <div>
                    <dt className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Email</dt>
                    <dd className="mt-1">
                      <a
                        href={`mailto:${CONTACT.email}`}
                        className="break-all font-semibold text-indigo-700 underline decoration-indigo-300 underline-offset-2 transition hover:text-indigo-900"
                      >
                        {CONTACT.email}
                      </a>
                    </dd>
                  </div>
                  <div>
                    <dt className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Registered office</dt>
                    <dd className="mt-1 font-medium leading-relaxed text-slate-700">{CONTACT.branch}</dd>
                  </div>
                </dl>
              </div>

              <div className="relative mt-10 flex justify-center lg:mt-0">
                <div className="absolute inset-0 -z-10 rounded-3xl bg-gradient-to-br from-indigo-200/60 via-cyan-200/40 to-violet-200/50 blur-2xl" aria-hidden />
                <div className="relative rounded-2xl border border-white/90 bg-gradient-to-br from-white to-indigo-50/80 p-8 shadow-[0_24px_50px_-18px_rgba(79,70,229,0.2)] ring-1 ring-indigo-100/80">
                  <img
                    src={IMG('company_logo.png')}
                    alt="ICONNECT LLP logo"
                    className="mx-auto h-32 w-auto max-w-[220px] object-contain sm:h-36"
                    loading="lazy"
                  />
                </div>
              </div>
            </GlassPanel>
          </div>
        </section>

        {/* Mission — bilingual */}
        <section className="px-4 pb-16 sm:pb-20">
          <div className="mx-auto max-w-6xl overflow-hidden rounded-[1.75rem] border border-white/90 bg-white/50 shadow-[0_28px_70px_-24px_rgba(79,70,229,0.15)] backdrop-blur-md">
            <div className="relative min-h-[220px] sm:min-h-[280px]">
              <img
                src={IMG('vision_mission.jpg')}
                alt="ICONNECT leadership and team collaborating"
                className="absolute inset-0 h-full w-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 via-transparent to-transparent" aria-hidden />
              <div className="absolute right-4 top-4 rounded-xl border border-white/80 bg-white/90 p-2 shadow-lg sm:right-6 sm:top-6 sm:p-3">
                <img src={IMG('company_logo.png')} alt="ICONNECT LLP" className="h-10 w-auto object-contain sm:h-12" loading="lazy" />
              </div>
            </div>

            <div className="space-y-10 border-t border-slate-200/80 bg-gradient-to-br from-white via-indigo-50/40 to-cyan-50/30 p-8 sm:p-10 lg:p-12">
              <div>
                <BilingualBlockHeader
                  icon={<IconTarget className="h-5 w-5" />}
                  langLabel="English"
                  title="MISSION AND VISION"
                />
                <MissionList items={MISSION_EN} />
              </div>

              <div className="border-t border-slate-200/80 pt-10">
                <BilingualBlockHeader
                  icon={<IconTarget className="h-5 w-5" />}
                  langLabel="ಕನ್ನಡ"
                  title="ಧ್ಯೇಯ ಮತ್ತು ದೂರದೃಷ್ಟಿ"
                />
                <MissionList items={MISSION_KN} />
              </div>
            </div>
          </div>
        </section>

        {/* Projects */}
        <section className="px-4 pb-16 sm:pb-20">
          <div className="mx-auto max-w-6xl">
            <SectionLabel
              kicker="What is next"
              title="Our upcoming projects"
              subtitle="Retail, service, and education brands designed to scale with India’s growth — executed with the same rigor we bring to every venture."
              align="center"
            />
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
              {UPCOMING_PROJECTS.map((p) => (
                <article
                  key={p.title}
                  className="group relative overflow-hidden rounded-2xl border border-white/90 bg-white/80 shadow-[0_16px_44px_-20px_rgba(79,70,229,0.12)] ring-1 ring-slate-200/60 transition duration-500 hover:-translate-y-0.5 hover:border-indigo-200/90 hover:shadow-[0_24px_50px_-16px_rgba(79,70,229,0.2)]"
                >
                  <div className="relative aspect-[4/3] overflow-hidden">
                    <img
                      src={IMG(p.image)}
                      alt={p.title}
                      className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-white via-white/95 to-transparent pt-14 pb-4">
                      <h3 className="text-center text-sm font-semibold text-slate-900 sm:text-base">{p.title}</h3>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Leadership */}
        <section className="px-4 pb-16 sm:pb-20">
          <div className="mx-auto max-w-6xl">
            <GlassPanel className="p-8 sm:p-10 lg:p-14">
              <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
                <SectionLabel
                  kicker="Leadership"
                  title="Key people"
                  subtitle="Experienced operators guiding strategy, compliance, and day-to-day scale across the group."
                />
                <img src={IMG('company_logo.png')} alt="" className="h-9 w-auto opacity-90 sm:h-10" loading="lazy" />
              </div>
              <div className="mt-4 grid gap-8 sm:grid-cols-3 sm:gap-6 lg:gap-8">
                {TEAM.map((m) => (
                  <article key={m.name} className="group text-center">
                    <div className="relative mx-auto max-w-[220px]">
                      <div
                        className="absolute -inset-0.5 rounded-2xl bg-gradient-to-br from-indigo-300/90 via-cyan-200/80 to-violet-300/80 opacity-80 blur-sm transition duration-500 group-hover:opacity-100"
                        aria-hidden
                      />
                      <div className="relative overflow-hidden rounded-2xl ring-1 ring-white shadow-md">
                        <img src={IMG(m.image)} alt={m.name} className="aspect-[3/4] w-full object-cover object-top transition duration-500 group-hover:scale-[1.02]" loading="lazy" />
                      </div>
                    </div>
                    <h3 className="mt-5 text-sm font-semibold uppercase tracking-wide text-slate-900 sm:text-[0.95rem]">{m.name}</h3>
                    <p className="mt-1 text-xs font-medium text-slate-600 sm:text-sm">{m.role}</p>
                  </article>
                ))}
              </div>
            </GlassPanel>
          </div>
        </section>

        {/* Terms & conditions — bilingual */}
        <section className="px-4 pb-16 sm:pb-20" aria-labelledby="terms-heading">
          <div className="mx-auto max-w-6xl">
            <GlassPanel className="p-8 sm:p-10 lg:p-14">
              <SectionLabel
                kicker="Legal"
                title="Terms &amp; conditions"
                subtitle="Please read these terms carefully before redeeming coupons or participating in ICONNECT programmes."
              />

              <div className="space-y-10">
                <div>
                  <BilingualBlockHeader
                    icon={<IconTarget className="h-5 w-5" />}
                    langLabel="English"
                    title="Terms &amp; conditions"
                  />
                  <TermsList items={TERMS_EN} listId="terms-heading" />
                </div>

                <div className="border-t border-slate-200/80 pt-10">
                  <BilingualBlockHeader
                    icon={<IconTarget className="h-5 w-5" />}
                    langLabel="ಕನ್ನಡ"
                    title="ನಿಯಮಗಳು ಮತ್ತು ಶರತ್ತುಗಳು"
                  />
                  <div lang="kn" style={{ fontFamily: "'Noto Sans Kannada', system-ui, sans-serif" }}>
                    <TermsList items={TERMS_KN} />
                  </div>
                </div>
              </div>
            </GlassPanel>
          </div>
        </section>

        {/* Head office */}
        <section className="px-4 pb-24">
          <div className="mx-auto max-w-6xl">
            <SectionLabel kicker="Visit us" title="Head office" />
            <div className="overflow-hidden rounded-[1.75rem] border border-white/90 bg-white/60 shadow-[0_32px_80px_-28px_rgba(79,70,229,0.18)] ring-1 ring-indigo-950/[0.05] backdrop-blur-sm">
              <div className="relative">
                <img
                  src={IMG('company_location.png')}
                  alt="ICONNECT LLP head office"
                  className="h-auto min-h-[220px] w-full object-cover sm:min-h-[320px]"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/55 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-10">
                  <div className="mx-auto max-w-2xl rounded-2xl border border-white/80 bg-white/90 px-5 py-4 shadow-xl shadow-slate-900/10 backdrop-blur-xl sm:px-8 sm:py-5">
                    <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-indigo-600">Address</p>
                    <p className="mt-2 text-sm font-medium leading-relaxed text-slate-800 sm:text-base">{CONTACT.branch}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <AboutFooter />
      </div>
    </div>
  );
}

export default About;
